'use strict';

module.exports = function isValidXss(requestURL) {
  var xssRegex = /(\b)(on\w+)=|javascript|(<\s*)(\/*)script/gi;
  return xssRegex.test(requestURL);
};




//////////////////
// WEBPACK FOOTER
// ./lib/helpers/isValidXss.js
// module id = 21
// module chunks = 0